import { logError } from 'app/services/logger';
import { useCallback, useEffect } from 'react';

/**
 * Minimal implementation for notification sound
 * @arg volume - Specifies the current volume of the audio/video. Must be a number between 0.0 and 1.0.
 */
interface SoundOptions {
  volume: number;
}

const sounds = new Map<string, HTMLAudioElement>();

function getAudio(soundUrl: string): HTMLAudioElement {
  if (sounds.has(soundUrl)) {
    // @ts-ignore
    return sounds.get(soundUrl);
  } else {
    const audio = document.createElement('audio');
    audio.src = soundUrl;
    sounds.set(soundUrl, audio);

    return audio;
  }
}

export const useSound = (soundUrl: string, options?: SoundOptions) => {
  const audio = getAudio(soundUrl);

  useEffect(() => {
    audio.volume = options?.volume ?? 1;
  }, [audio, options?.volume]);

  const play = useCallback(() => audio.play().catch(handleError), [audio]);
  const pause = useCallback(() => audio.pause(), [audio]);

  return [play, pause];
};

function handleError(error: Error) {
  logError(error.message);
}
